const colorMap = new Map([
  ["Black", "#000000"],
  ["Grey", "#999d9e"],
  ["White", "white"],
  ["Blue", "#2e3cbf"],
  ["Navy", "#2e3cbf"],
  ["Blue / Navy", "#2e3cbf"],
  ["Green", "#32a14f"],
  ["Brown", "#94663e"],
  ["Cream", "#e3d8a3"],
  ["Khaki", "#e3d8a3"],
  ["Yellow", "#fcf947"],
  ["Orange", "#e89b0c"],
  ["Red", "#ed1f1f"],
  ["Pink", "pink"],
  ["Purple", "purple"],
  ["Cream / Khaki", "#e3d8a3"],
]);


var isOthers = false;
var isCategories = false;
var isPages = false;
var isProducts = false;

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      // console.log("WIZZY INIT");
      data.filters.configs.layout = "v1";
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.endpoints.common = "https://uranus-api.wizsearch.in";
      data.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [".wizzy-main"]
      
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log("WIZZY INIT");
      data.filters.configs.layout = "v1";
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [".wizzy-main"]
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log(data.filters, "BEFORE_FILTER_EXECUTED");
      
      // data.filters.inStock = ["true","false"];
      var inStockFilterValue = data.filters?.inStock;
      if(typeof inStockFilterValue === 'undefined') {
        data.filters.inStock = [true, false];
      }

      if (data.filters) {
        // if (data.filters?.type === "NO_RESULTS_FOUND" || data.filters?.type === "AUTOCOMPLETE_DEFAULT") {

          if (Array.isArray(data.filters.sort)) {
            const sortExists = data.filters.sort.some(
              sort =>
                sort.field === "product_wizzy-best-selling_sortOrder:float" &&
                sort.order === "asc"
            );

            if (!sortExists) {
              data.filters.sort.push({
                field: "product_wizzy-best-selling_sortOrder:float",
                order: "asc"
              });
            }
          }
        // }
      }
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      // console.log(data,"BEFORE_RENDER_RESULTS");

      
      if(data.response.payload){
        if(data.response.payload.facets){
          const FacetList = data.response.payload.facets;
          // console.log(FacetList,"Facet List");
          if(FacetList){
            FacetList.forEach(facet => {
              if(facet.key === "product_colors_custom"){
                const colorsList = facet.data;
                if(colorsList){
                  // console.log(colorsList,"Colors List");
                  colorsList.forEach(color => {
                    const colorKey = color.key;
                    const backgroundHex = colorMap.get(colorKey);
                    // console.log(backgroundHex ,colorKey , "backgroundHex");
                    // color.backgroundHex = backgroundHex;
                    // color.isBackgroundHex = true;
                    color.isSwatch = true;
                    color.isVisualSwatch = true;
                    color.swatchValue = backgroundHex;
                    color.data = {
                          value: color.key,
                          swatch: {
                              type: 'visual',
                              value: backgroundHex
                          }
                      }
                  })
                }
              }
            })
          }
        }
      }
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // console.log(data,"BEFORE_SEARCH_EXECUTED");

      // data.inStock = [true,false];
      data.minQueryLength = 1;
      

      const floatingFilter = document.querySelector('.facets__floating-filter');
      if (floatingFilter) {
        floatingFilter.style.display = 'none';
      }

      if(window.document.documentElement.clientWidth < 768){
        const filterButton = document.querySelector(".wizzy-search-and-filter-btn");
        if (filterButton) {
            filterButton.style.display = "block";
        }
      }

      if (/^\d{5}$/.test(data.q)) {
        data.q = "store";
      }

      var searchDrawerCloseButton = document.querySelector('#header-search-drawer button[data-action="close-drawers"]');
      if (searchDrawerCloseButton) {
        searchDrawerCloseButton.click();
      }

      if (data.sort) {
        if (Array.isArray(data.sort)) {
          const sortExists = data.sort.some(
            sort =>
              sort.field === "product_wizzy-best-selling_sortOrder:float" &&
              sort.order === "asc"
          );

          if (!sortExists) {
            data.sort.push({
              field: "product_wizzy-best-selling_sortOrder:float",
              order: "asc"
            });
          }
        }
      }
      
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data,"VIEW_RENDERED");
      var inStockBtn = document.querySelector('.wizzy-search-filters-inStock');

      if (inStockBtn) {
        // inStockBtn.addEventListener('click', handleButtonClickForInstock);
        inStockBtn.addEventListener('click', function(){
          var inStockFilter = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-top .wizzy-facet-body .wizzy-facet-list .wizzy-facet-list-item[data-key="_true"]');
          if (inStockFilter) {
            inStockFilter.click();
          }
        });
      }

      var filterCloseBtnMobile = document.querySelector('.wizzy-filters-overlay-close-btn');

      if (filterCloseBtnMobile) {
        filterCloseBtnMobile.addEventListener('click', function(){
          var filterOverlay = document.querySelector('.wizzy-filters-bg');

          if (filterOverlay) {
            filterOverlay.click();
          }
        });
      }

      var instockValue = data.data.response.payload.filters?.inStock;
        // console.log("Wizzy BEFORE_RENDER_INSTOCK", instockValue);
        if (instockValue) {
          if (instockValue[0] === "true") {
            // console.log("BEFORE_RENDER_INSTOCKCHECK", instockValue);
            var inputForInstock = document.querySelector('#wizzy-search-filters-inStock-input');
            var inputForInstockMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');
            if (inputForInstock) {
             inputForInstock.setAttribute("checked", ""); 
            }
            if (inputForInstockMobile) {
              inputForInstockMobile.setAttribute("checked", ""); 
            }
          }
        }

      var inStockBlock = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock');
    
      if (!inStockBlock) {
        var inStockToggle = document.querySelector('.wizzy-search-filters-inStock');
        if (inStockToggle) {
          inStockToggle.style.opacity = 0;
          inStockToggle.style.pointerEvents = 'none'; // Prevents clicks/interactions
        }
      }


      var inStockBtnForMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');

      if (inStockBtnForMobile) {
        inStockBtnForMobile.addEventListener('click', handleButtonClickForInstock);
      }


      if (window.innerWidth < 768) {
        var madeToOrderBlock = document.querySelector('.wizzy-filters-facet-block.facet-block-product_made_to_order_custom');
        var madeToOrderListItems = madeToOrderBlock?.querySelectorAll('.wizzy-facet-list-item');
        
        if (madeToOrderBlock && madeToOrderListItems?.length === 1) {
          var onlyItemLabel = madeToOrderListItems[0].querySelector('.facet-item-label-value')?.textContent.trim().toLowerCase();
          
          if (onlyItemLabel === 'no') {
            madeToOrderBlock.style.display = 'none';
          }
        }
      }

      var madeToOrderBtn = document.querySelector('.wizzy-filters-facet-block.facet-block-product_made_to_order_custom .wizzy-search-filters-toggle-input-class')

      if (madeToOrderBtn) {
        madeToOrderBtn.addEventListener('click', handleButtonClickForMadeToOrder);
      }

      var madeToOrderValue = data.data.response.payload.filters?.attributes;
        // console.log("Wizzy BEFORE_RENDER_INSTOCK", instockValue);
        if (madeToOrderValue && typeof madeToOrderValue === 'object') {
            if (madeToOrderValue.product_made_to_order_custom?.includes("Yes")) {
                var inputForMadeToOrderMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-product_made_to_order_custom .wizzy-search-filters-toggle-input-class');
                if (inputForMadeToOrderMobile) {
                 inputForMadeToOrderMobile.setAttribute("checked", ""); 
                }
            }
        }

      var sourceElement = document.querySelector('.wizzy-search-sort-wrapper');
  
      if (sourceElement) {
          var clonedContent = sourceElement.cloneNode(true);
          
          var targetDiv = document.querySelector('.wizzy-sort-wrapper-in-filter');
          
          if (targetDiv && !targetDiv.querySelector('.wizzy-search-sort-wrapper')) {
              targetDiv.appendChild(clonedContent);
          }
      }

      if (window.innerWidth < 768) {
        var sortInFilter = document.querySelector('.wizzy-search-filters-left-wrapper .wizzy-common-select-selector');
        if (sortInFilter && !sortInFilter.classList.contains('click-listener-attached')) {
            sortInFilter.addEventListener('click', function(event){
                event.preventDefault();
                event.stopPropagation();
                var sortOptions = document.querySelector('.wizzy-common-select-options');
                if (sortOptions) {
                    if (sortOptions.style.display === 'none' || sortOptions.style.display === '') {
                        sortOptions.style.display = 'grid';
                    } else {
                        sortOptions.style.display = 'none';
                    }
                }
            });
            // Add a class to indicate that the event listener has been attached
            sortInFilter.classList.add('click-listener-attached');
        }
    }

      var applyFiltersBtn = document.getElementById('wizzy-apply-filters-button');

      if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', function (){
          var filterOverlay = document.querySelector('.wizzy-filters-bg');
      
          if (filterOverlay) {
            filterOverlay.click();
          }
        });
      }

      gridFiltersToggleOnOverflow();


      ///////////////////////////////////////////
        
      const mainElement = document.querySelector('.wizzy-search-results-rendered #main');
        // console.log(mainElement,"mainElement");
        if (mainElement) {
          Array.from(mainElement.children).forEach(child => {
            if (!child.classList.contains('wizzy-main') && !child.classList.contains('shopify-section-group-footer-group')) {
              child.style.display = 'none';
              // console.log("Hii wizzy");
            }
          });
        }
        
      ///////////////////////////////////////////

      if(window.document.documentElement.clientWidth < 768){
        const facetElement = document.querySelector('.wizzy-facet-list-item.facet-has-swatch');
        if (facetElement) {
          facetElement.parentElement.classList.add('wizzy-color-facets');
        }
      }
        
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      var inStockBtn = document.querySelector('.wizzy-search-filters-inStock');

        if (inStockBtn) {
          inStockBtn.addEventListener('click', handleButtonClickForInstock);
        }

        var filterCloseBtnMobile = document.querySelector('.wizzy-filters-overlay-close-btn');

        if (filterCloseBtnMobile) {
          filterCloseBtnMobile.addEventListener('click', function(){
            var filterOverlay = document.querySelector('.wizzy-filters-bg');

            if (filterOverlay) {
              filterOverlay.click();
            }
          });
        }

        var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
          // console.log("BEFORE_RENDER_INSTOCK", instockValue);
          if (instockValue) {
            if (instockValue[0] === "true") {
              // console.log("BEFORE_RENDER_INSTOCKCHECK", instockValue);
              var inputForInstock = document.querySelector('#wizzy-search-filters-inStock-input');
              var inputForInstockMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');
              if (inputForInstock) {
               inputForInstock.setAttribute("checked", ""); 
              }
              if (inputForInstockMobile) {
                inputForInstockMobile.setAttribute("checked", ""); 
              }
            }
          }

          var inStockBlock = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock');
    
          if (!inStockBlock) {
            var inStockToggle = document.querySelector('.wizzy-search-filters-inStock');
            if (inStockToggle) {
              inStockToggle.style.opacity = 0;
              inStockToggle.style.pointerEvents = 'none'; // Prevents clicks/interactions
            }
          }



        var inStockBtnForMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class');

        if (inStockBtnForMobile) {
          inStockBtnForMobile.addEventListener('click', handleButtonClickForInstock);
        }


        if (window.innerWidth < 768) {
          var madeToOrderBlock = document.querySelector('.wizzy-filters-facet-block.facet-block-product_made_to_order_custom');
          var madeToOrderListItems = madeToOrderBlock?.querySelectorAll('.wizzy-facet-list-item');
          
          if (madeToOrderBlock && madeToOrderListItems?.length === 1) {
            var onlyItemLabel = madeToOrderListItems[0].querySelector('.facet-item-label-value')?.textContent.trim().toLowerCase();
            
            if (onlyItemLabel === 'no') {
              madeToOrderBlock.style.display = 'none';
            }
          }
        }

        var madeToOrderBtn = document.querySelector('.wizzy-filters-facet-block.facet-block-product_made_to_order_custom .wizzy-search-filters-toggle-input-class')

        if (madeToOrderBtn) {
          madeToOrderBtn.addEventListener('click', handleButtonClickForMadeToOrder);
        }

        var madeToOrderValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.attributes;
          // console.log("BEFORE_RENDER_INSTOCK", instockValue);
          if (madeToOrderValue && typeof madeToOrderValue === 'object') {
              if (madeToOrderValue.product_made_to_order_custom?.includes("Yes")) {
                  var inputForMadeToOrderMobile = document.querySelector('.wizzy-filters-facet-block.facet-block-product_made_to_order_custom .wizzy-search-filters-toggle-input-class');
                  if (inputForMadeToOrderMobile) {
                   inputForMadeToOrderMobile.setAttribute("checked", ""); 
                  }
              }
          }

        var sourceElement = document.querySelector('.wizzy-search-sort-wrapper');
    
        if (sourceElement) {
            var clonedContent = sourceElement.cloneNode(true);
            
            var targetDiv = document.querySelector('.wizzy-sort-wrapper-in-filter');
            
            if (targetDiv && !targetDiv.querySelector('.wizzy-search-sort-wrapper')) {
                targetDiv.appendChild(clonedContent);
            }
        }

        if (window.innerWidth < 768) {
          var sortInFilter = document.querySelector('.wizzy-search-filters-left-wrapper .wizzy-common-select-selector');
          if (sortInFilter && !sortInFilter.classList.contains('click-listener-attached')) {
              sortInFilter.addEventListener('click', function(event){
                  event.preventDefault();
                  event.stopPropagation();
                  var sortOptions = document.querySelector('.wizzy-common-select-options');
                  if (sortOptions) {
                      if (sortOptions.style.display === 'none' || sortOptions.style.display === '') {
                          sortOptions.style.display = 'grid';
                      } else {
                          sortOptions.style.display = 'none';
                      }
                  }
              });
              // Add a class to indicate that the event listener has been attached
              sortInFilter.classList.add('click-listener-attached');
          }
      }

        var applyFiltersBtn = document.getElementById('wizzy-apply-filters-button');

        if (applyFiltersBtn) {
          applyFiltersBtn.addEventListener('click', function (){
            var filterOverlay = document.querySelector('.wizzy-filters-bg');
        
            if (filterOverlay) {
              filterOverlay.click();
            }
          });
        }

      gridFiltersToggleOnOverflow();
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      //console.log("Wizzy AFTER_PRODUCTS_TRANSFORMED" ,data);
      data.forEach(product => {
        product.attributes?.forEach((attribute) => {
          if (attribute.id === "product_summaryData_okendo") {
            var parsedValue = JSON.parse(attribute.values[0].value[0]);
            product.reviewCount = parsedValue.reviewCount;
            product.reviewAverageValue = parsedValue.reviewAverageValue;
          }
          if (attribute.id === "product_made_to_order_custom") {
            var madeToOrderVal = attribute.values[0].value[0];
            if (madeToOrderVal && madeToOrderVal === "Yes") {
              product.madeToOrder = true;
            }
          }
          if (attribute.id === "product___label_tags") {
            product.labelValue = attribute.values[0].value[0];
          }
          if (attribute.id === "product_combined_listing_metaobject_custom") {
            var swatchValue = attribute.values[0].value[0];
            if (isJsonString(swatchValue)) {
              var productSwatchList = JSON.parse(swatchValue);
              let currentProductId = (product.groupId || product.id)?.toString();

              // console.log("wizzy id", currentProductId);
              let matchedIndex = productSwatchList.findIndex(
                (swatch) => swatch.swatchGroupId?.toString() === currentProductId
              );

              // console.log("wizzy matchedIndex", matchedIndex);
              if (matchedIndex > -1) {
                let matchedSwatch = productSwatchList.splice(matchedIndex, 1)[0];
                matchedSwatch.isSwatchSelected = true;
                productSwatchList.unshift(matchedSwatch);
              }
              // console.log("Wizzy swatchList", productSwatchList);
              product.fullSwatchList = productSwatchList;

              const isMobile = window.innerWidth <= 768;
              const swatchLimit = isMobile ? 4 : 7;
          
              product.swatchList = productSwatchList.slice(0, swatchLimit);
              if (Array.isArray(productSwatchList)) {
                var swatchListLength = productSwatchList.length;
                if (swatchListLength >= 10) {
                  product.swatchDesktopOverflow = true;
                }
                if (swatchListLength > 4) {
                  product.swatchMobileOverflow = true;
                }
              }
            }
          }
        });
        if (window.wizzyCountry !== 'US') {
          prepareWizzyNonUsProduct(product);
        }
      });
      return data;
    }, 1
  );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      
      $('body').addClass('wizzy-search-results-rendered');

    ///////////////////////////////////////////
    const mainElement = document.querySelector('.wizzy-search-results-rendered #main');
      // console.log(mainElement,"mainElement");
      if (mainElement) {
        Array.from(mainElement.children).forEach(child => {
          if (!child.classList.contains('wizzy-main') && !child.classList.contains('shopify-section-group-footer-group')) {
            child.style.display = 'none';
            // console.log("Hii wizzy");
          }
        });
      }
    ///////////////////////////////////////////

       if(window.document.documentElement.clientWidth < 768){
        const facetElement = document.querySelector('.wizzy-facet-list-item.facet-has-swatch');
        if (facetElement) {
          facetElement.parentElement.classList.add('wizzy-color-facets');
        }
      }
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log("WIZZY BEFORE_AUTOCOMPLETE_RENDER", data);

      // if (window.innerWidth > 768) {
        var query = data.payload?.products?.filters?.q;

        if (query) {
          var sections = window.wizzyConfig?.autocomplete?.menu?.sections;
          if (sections) {
            if (query.toLowerCase() === "store" || query.toLowerCase() === "stores") {
              sections = ["pages", "others", "categories"];
              window.wizzyConfig.autocomplete.menu.sections = sections;
            } else {
              sections = ["others", "categories", "pages"];
              window.wizzyConfig.autocomplete.menu.sections = sections;
            }
          }
        }
      // }

      // DON'T REMOVE

      // setTimeout(function(){
      //   var autoCompleteWrapper = document.querySelector('.wizzy-autocomplete-wrapper');
      //   if (autoCompleteWrapper) {
      //     console.log("Wizzy");
      //     var suggestionsTitle = document.querySelector('.wizzy-autocomplete-wrapper .wizzy-autocomplete-suggestion-title');
      //     var productsTitle = document.querySelector('.wizzy-autocomplete-wrapper .wizzy-autocomplete-products-title');
      //     var suggestionsWrapper = document.querySelector('.wizzy-autocomplete-wrapper .wizzy-autocomplete-suggestions');
      //     var productsWrapper = document.querySelector('.wizzy-autocomplete-wrapper .wizzy-autocomplete-top-products');
      //     if (autoCompleteWrapper.classList.contains('withoutSuggestions') && autoCompleteWrapper.classList.contains('withoutTopProducts')) {
      //       if (productsTitle) {
      //         productsTitle.classList.add('wizzy-not-available');
      //         productsTitle.classList.remove('wizzy-active');
      //       }
      //       if (productsWrapper) {
      //         productsWrapper.classList.remove('wizzy-active');
      //       }
      //       if (suggestionsTitle) {
      //         suggestionsTitle.classList.add('wizzy-not-available');
      //         suggestionsTitle.classList.remove('wizzy-active');
      //       }
      //       if (suggestionsWrapper) {
      //         suggestionsWrapper.classList.remove('wizzy-active');
      //       }
      //     } else if (autoCompleteWrapper.classList.contains('withoutSuggestions')) {
      //       if (productsTitle) {
      //         productsTitle.classList.remove('wizzy-not-available');
      //         productsTitle.classList.add('wizzy-active');
      //       }
      //       if (productsWrapper) {
      //         productsWrapper.classList.add('wizzy-active');
      //       }
      //       if (suggestionsTitle) {
      //         suggestionsTitle.classList.add('wizzy-not-available');
      //         suggestionsTitle.classList.remove('wizzy-active');
      //       }
      //       if (suggestionsWrapper) {
      //         suggestionsWrapper.classList.remove('wizzy-active');
      //       }
      //     } else if (autoCompleteWrapper.classList.contains('withoutTopProducts')) {
      //       if (productsTitle) {
      //         productsTitle.classList.add('wizzy-not-available');
      //         productsTitle.classList.remove('wizzy-active');
      //       }
      //       if (productsWrapper) {
      //         productsWrapper.classList.remove('wizzy-active');
      //       }
      //       if (suggestionsTitle) {
      //         suggestionsTitle.classList.remove('wizzy-not-available');
      //         suggestionsTitle.classList.add('wizzy-active');
      //       }
      //       if (suggestionsWrapper) {
      //         suggestionsWrapper.classList.add('wizzy-active');
      //       }
      //     } else {
      //       if (productsTitle) {
      //         productsTitle.classList.remove('wizzy-not-available');
      //         productsTitle.classList.add('wizzy-active');
      //       }
      //       if (productsWrapper) {
      //         productsWrapper.classList.add('wizzy-active');
      //       }
      //       if (suggestionsTitle) {
      //         suggestionsTitle.classList.remove('wizzy-not-available');
      //         suggestionsTitle.classList.remove('wizzy-active');
      //       }
      //       if (suggestionsWrapper) {
      //         suggestionsWrapper.classList.remove('wizzy-active');
      //       }
      //     }

      //     if (productsTitle && productsWrapper && suggestionsTitle && suggestionsWrapper) {
      //       suggestionsTitle.addEventListener('click', function(){
      //         productsTitle.classList.remove('wizzy-active');
      //         productsWrapper.classList.remove('wizzy-active');
      //         suggestionsTitle.classList.add('wizzy-active');
      //         suggestionsWrapper.classList.add('wizzy-active');
      //       });

      //       productsTitle.addEventListener('click', function(){
      //         suggestionsTitle.classList.remove('wizzy-active');
      //         suggestionsWrapper.classList.remove('wizzy-active');
      //         productsTitle.classList.add('wizzy-active');
      //         productsWrapper.classList.add('wizzy-active');
      //       });
      //     }
      //   }
      // }, 100);

      // setTimeout(function(){
      //   if (window.innerWidth <= 768) {
      //     splitSuggestionsIntoColumns();
      //     enableTitleClickToShowSections();
      //   }
      // }, 50);

      var input = document.querySelector(
        window.wizzyConfig.search.input.dom || '.wizzy-search-input'
      );
      var typed = input ? input.value.trim() : '';
      if (data.isForDefault && !data.isForEmptyResult && typed === '') {
        window.wizzyConfig.pageStore.searchInputValue = ' ';
      }

      setTimeout(() => {
        updateWizzyMarketPrices();
      }, 0);
      
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log("Wizzy VIEW_RENDERED" ,data);
      // if (window.innerWidth < 768) {
      //   splitSuggestionsIntoColumns();
      // }

      updateWizzyMarketPrices();

      return data;
    }, 1
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log("Wizzy PRODUCTS_CACHED_RESULTS_RENDERED" ,data);
      // if (window.innerWidth < 768) {
      //   splitSuggestionsIntoColumns();
      // }

      updateWizzyMarketPrices();

      return data;
    }, 1
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      data.minQueryLength = 1;

      if (data.q.toLowerCase() === "stores" || /^\d{5}$/.test(data.q)) {
        data.q = "store";
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
    function (data) {
      
      setTimeout(() => {

        if (window.GorgiasChat) {
          window.GorgiasChat.open();
        }
      }, 2000);

      return data;
    }, 1
  );
};

function updateURL(url, key, value) {
    const urlObj = new URL(url);
    if (urlObj.searchParams.has(key)) {
        urlObj.searchParams.delete(key);
    } else {
        urlObj.searchParams.append(key, value);
    }

    var newURL = urlObj.toString().replace(/%5B%5D/g, '[]');

    return newURL;
}


function handleButtonClickForInstock() {
    const currentURL = window.location.href;
    const paramKey = 'inStock[]';
    const paramValue = 'true';

    const updatedURL = updateURL(currentURL, paramKey, paramValue);
    window.executeWizzyFiltersFromURL(updatedURL);
}

function handleButtonClickForMadeToOrder() {
    const currentURL = window.location.href;
    const paramKey = 'product_made_to_order_custom[]';
    const paramValue = 'Yes';

    const updatedURL = updateURL(currentURL, paramKey, paramValue);
    window.executeWizzyFiltersFromURL(updatedURL);
}

function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");

        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;

          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}

function isJsonString(str) {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed); // Only return true if it's an array
  } catch (e) {
    return false;
  }
}

/*
  Non-US only: fetch presentment price from /products/{handle}.js and paint into cards.
  US: leave Wizzy $ [[sellingPrice]] as-is — no helpers run.
*/
function getWizzyProductHandle(product) {
  if (product.url) {
    var match = String(product.url).match(/\/products\/([^/?#]+)/);
    if (match) return decodeURIComponent(match[1]);
  }
  var attrs = product.attributes || [];
  for (var i = 0; i < attrs.length; i++) {
    if (attrs[i].id === 'product_handle' && attrs[i].values && attrs[i].values[0]) {
      return attrs[i].values[0].value[0];
    }
  }
  return null;
}

function fetchWizzyProductPrice(handle) {
  if (!handle || window.wizzyPriceCache[handle] != null || window.wizzyPriceInflight[handle]) {
    return window.wizzyPriceInflight[handle];
  }

  window.wizzyPriceInflight[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
    credentials: 'same-origin',
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (product) {
      window.wizzyPriceCache[handle] = product.price;
      delete window.wizzyPriceInflight[handle];
      return product.price;
    })
    .catch(function () {
      delete window.wizzyPriceInflight[handle];
    });

  return window.wizzyPriceInflight[handle];
}

function prepareWizzyNonUsProduct(product) {
  var handle = getWizzyProductHandle(product);
  product.productHandle = handle;
  product.hideUntilMarketPrice = true;
  fetchWizzyProductPrice(handle);
}

function paintWizzyMarketPrices() {
  document.querySelectorAll('.wizzy-result-product[data-handle]').forEach(function (card) {
    var handle = card.getAttribute('data-handle');
    var cents = window.wizzyPriceCache[handle];
    if (cents == null) return;

    var priceEl = card.querySelector('sale-price');
    if (!priceEl) return;

    priceEl.innerHTML =
      '<span class="sr-only">Sale price</span>' + Shopify.formatMoney(cents);
    priceEl.classList.remove('wizzy-price-pending');
  });
}

function updateWizzyMarketPrices() {
  if (window.wizzyCountry === 'US') return;

  var pending = [];
  document.querySelectorAll('.wizzy-result-product[data-handle]').forEach(function (card) {
    var handle = card.getAttribute('data-handle');
    if (!handle) return;
    var req = fetchWizzyProductPrice(handle);
    if (req) pending.push(req);
  });

  if (pending.length) {
    Promise.all(pending).then(paintWizzyMarketPrices);
  } else {
    paintWizzyMarketPrices();
  }
}


/////////////////////////////// Muation observer one /////////////////////////////////////////////////


// Select the target element
const targetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateBodyClass() {
  const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
  }
}

const config = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };
const callback = function (mutationsList, wizzyObserver) {
  for (const mutation of mutationsList) {
    updateBodyClass();
    break; // One update is enough per mutation batch
  }
};

const wizzyObserver = new MutationObserver(callback);
if (targetNode) {
  wizzyObserver.observe(targetNode, config);
  updateBodyClass();
}


// if (window.innerWidth < 768) {
//   const searchBar = document.querySelector(
//     ".cc-search-mobile .search-input>input"
//   );
//   if (searchBar) {
//     searchBar.addEventListener("click", () => {
//       setTimeout(() => {
//         let autoCompleteArrows = document.querySelectorAll(
//           ".autocomplete-text-wrapper"
//         );
//         if (autoCompleteArrows) {
//           autoCompleteArrows.forEach((arrow) => {
//             if (arrow) {
//               arrow.addEventListener("click", () => {
//                 searchBar.value =
//                   arrow.parentElement.getAttribute("data-searchterm");
//                 searchBar.focus();
//                 console.log("wizzy", arrow.parentElement.getAttribute("data-searchterm"));
//               });
//             }
//           });
//         }
//       }, 250);
//     });
//   }
// }

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 768) {
    const searchBar = document.querySelector(".cc-search-mobile .search-input > input");

    if (searchBar) {
      searchBar.addEventListener("click", () => {
        const searchObserver = new MutationObserver(() => {
          checkforScroll();
          const autoCompleteArrows = document.querySelectorAll(".autocomplete-text-wrapper");

          autoCompleteArrows.forEach((arrow) => {
            // Prevent attaching duplicate listeners
            if (!arrow.hasAttribute("data-wizzy-bound")) {
              arrow.setAttribute("data-wizzy-bound", "true");

              arrow.addEventListener("click", () => {
                const term = arrow.parentElement.getAttribute("data-searchterm");
                searchBar.value = term;
                searchBar.focus();
                // console.log("wizzy", term);
              });
            }
          });
        });

        searchObserver.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    }
  }
});

function checkforScroll() {
  if (window.innerWidth < 768) {
    window.addEventListener("scroll", function () {
      var autoCompleteWrapper = document.querySelector(
        ".wizzy-autocomplete-wrapper"
      );
  
      if (autoCompleteWrapper) {
        var predictiveSearch = document.querySelector(
          ".cc-search-mobile .search-input > input"
        );
        if (predictiveSearch) {
          var positionInfo = predictiveSearch.getBoundingClientRect();
          // var left = positionInfo.left;
          var top = positionInfo.top + positionInfo.height + 4;
          autoCompleteWrapper.style.setProperty("top", top + "px", "important");
          // autoCompleteWrapper.style.setProperty("left", left + "px", "important");
        }
      }
    });
  }
}




/////////////////////////////////////////////

const addToCartButton = document.getElementById("addtocart-wizzy");

if (addToCartButton) {
    addToCartButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const filterElement = document.querySelector(".wizzy-filters-mobile-entry");
        if (filterElement) {
            filterElement.click();
        }
    });
}

// Don't Remove
function splitSuggestionsIntoColumns() {
  const wrapper = document.querySelector('.wz-autocomplete-sugegstions-products-wrapper');
  if (!wrapper) return;

  const suggestionsBox = wrapper?.querySelector('.wizzy-autocomplete-suggestions');
  const suggestionsList = suggestionsBox?.querySelector('.autocomplete-suggestions-list');
  const topProductsBox = wrapper?.querySelector('.wizzy-autocomplete-top-products');
  if (!suggestionsList) {
    return;
  }
  let items = Array.from(suggestionsList?.children);

  // Create a container for main titles
  let titlesContainer = document.querySelector('.wizzy-autocomplete-main-titles');
  if (!titlesContainer) {
    titlesContainer = document.createElement('div');
    titlesContainer.className = 'wizzy-autocomplete-main-titles';
  }
  titlesContainer.innerHTML = '';

  if (topProductsBox) {
    const topProductsTitle = document.createElement('div');
    topProductsTitle.className = 'wizzy-autocomplete-title';
    topProductsTitle.classList.add('wizzy-autocomplete-title', 'h5');
    topProductsTitle.textContent = 'Top Products';
    const titleEl = topProductsBox?.querySelector('.top-products-title');
    const titleText = (titleEl && titleEl.textContent.trim()) ? titleEl.textContent.trim() : 'Top Products';
    topProductsTitle.textContent = titleText;
    topProductsTitle.dataset.index = 'top';
    titlesContainer.appendChild(topProductsTitle);
  }

  const sectionIndices = [];

  // Step 1: Detect titles
  items.forEach((li, index) => {
    if (li.classList.contains('autocomplete-item-head')) {
      sectionIndices.push({ index, dataIndex: li.dataset.index });
    }
  });

  // Step 2: Add end index for slicing
  sectionIndices.push({ index: items.length, dataIndex: 'end' });

  const sectionMap = {};

  for (let i = 0; i < sectionIndices.length - 1; i++) {
    const start = sectionIndices[i].index;
    const end = sectionIndices[i + 1].index;
    const dataIndex = sectionIndices[i].dataIndex;
    const sectionItems = items.slice(start, end);

    const titleItem = sectionItems.shift(); // Remove the head
    const titleText = titleItem?.textContent?.trim() || `Section ${dataIndex}`;

    // Add to titles container
    const titleBtn = document.createElement('div');
    titleBtn.classList.add('wizzy-autocomplete-title', 'h5');
    titleBtn.textContent = titleText;
    titleBtn.dataset.index = dataIndex;
    titlesContainer.appendChild(titleBtn);

    // Store section body (excluding the head)
    sectionMap[dataIndex] = sectionItems;
  }

  // Clean original wrapper
  wrapper.innerHTML = '';

  // Append in fixed order: Products > Suggestions > Collections > Pages
  if (topProductsBox) wrapper.appendChild(topProductsBox);

  const ordered = ["0", "1", "2"]; // Suggestions, Collections, Pages

  ordered.forEach(index => {
    const items = sectionMap[index];
    if (!items || items.length === 0) return;

    const sectionWrapper = document.createElement('div');
    sectionWrapper.className = `column-wrapper section-${index}`;
    sectionWrapper.dataset.index = index;

    const list = document.createElement('ul');
    list.className = 'autocomplete-suggestions-list';
    items.forEach(li => list.appendChild(li));

    sectionWrapper.appendChild(list);
    wrapper.appendChild(sectionWrapper);
    wrapper.prepend(titlesContainer);
  });
}


function enableTitleClickToShowSections() {
  const titles = document.querySelectorAll('.wizzy-autocomplete-title');

  titles.forEach(title => {

    title.addEventListener('click', () => {
      const index = title.dataset.index;

      // Hide all section divs
      document.querySelectorAll('.wizzy-autocomplete-top-products, .column-wrapper').forEach(section => {
        section.style.display = 'none';
      });

      // Remove active class from all titles
      titles.forEach(t => t.classList.remove('active'));

      // Add active class to clicked title
      title.classList.add('active');

      // Show the selected section
      if (index === 'top') {
        const topBox = document.querySelector('.wizzy-autocomplete-top-products');
        if (topBox) topBox.style.display = 'block';
      } else {
        const selected = document.querySelector(`.column-wrapper.section-${index}`);
        if (selected) selected.style.display = 'block';
      }
    });
  });

  titles[0]?.click();
}

let lastURL = location.href;

// Observe changes in <title> — this usually changes when SPA routes change
const titleEl = document.querySelector('title');
if (titleEl) {
    const titleObserver = new MutationObserver(() => {
        if (location.href !== lastURL) {
            lastURL = location.href;
        }
    });
    titleObserver.observe(titleEl, { childList: true });
}

// Handle back button
window.addEventListener('popstate', function () {
    if (lastURL.includes('/pages/search') && !(location.href.includes('/pages/search'))) {
      // console.log("wizzy reloaded", lastURL);
      history.scrollRestoration = 'manual';
      location.reload();
      window.scrollTo(0, 0);
    } else {
      history.scrollRestoration = 'auto';
    }
});


function updateTop(predictiveSearch, autoCompleteWrapper) {
  const positionInfo = predictiveSearch.getBoundingClientRect();
  const top = positionInfo.top + positionInfo.height + 4;
  autoCompleteWrapper.style.setProperty("top", top + "px", "important");
}

function updateAutocompleteWidth() {
  const input = document.querySelector("#header-search-drawer input");
  const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");

  if (!input || !autocomplete) {
    return;
  }

  const width = input.getBoundingClientRect().width;

  autocomplete.style.setProperty("width", `${width}px`, "important");
  autocomplete.style.setProperty("max-width", `${width}px`, "important");
}

if (window.innerWidth < 768) {
  const autocompleteWidthObserver = new MutationObserver(() => {
    updateAutocompleteWidth();
  });

  autocompleteWidthObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"]
  });

  window.addEventListener("resize", updateAutocompleteWidth);
}

if (window.innerWidth < 768) {
  var predictiveSearch = document.querySelector(".cc-search-mobile .search-input > input");

  if (predictiveSearch) {
    const autoCompleteObserver = new MutationObserver(() => {
      var autoCompleteWrapper = document.querySelector(".wizzy-autocomplete-wrapper");
      if (autoCompleteWrapper) {
        updateTop(predictiveSearch, autoCompleteWrapper);
        updateAutocompleteWidth();
      }
    });

    autoCompleteObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"] });

    window.addEventListener("resize", () => {
      var autoCompleteWrapper = document.querySelector(".wizzy-autocomplete-wrapper");
      if (autoCompleteWrapper) {
        updateTop(predictiveSearch, autoCompleteWrapper);
        updateAutocompleteWidth();
      }
    });

    window.addEventListener("scroll", () => {
      var autoCompleteWrapper = document.querySelector(".wizzy-autocomplete-wrapper");
      if (autoCompleteWrapper) {
        updateTop(predictiveSearch, autoCompleteWrapper);
        updateAutocompleteWidth();
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  var searchIconMob = document.querySelectorAll('c-header-v2 button.tap-area[data-action="open-search"]')[0];

  searchIconMob.addEventListener('click', function (event) {
    var searchInput = document.querySelector('#header-search-drawer input');

    setTimeout(function () {
      searchInput.click();
      searchInput.focus();
    }, 100); // Adjust delay as needed (e.g. 100-300ms)
  });
});

